module.exports = (a, b) => b.filter(item => a.indexOf(item) === -1);
